import { Badge, Box, Group, Stack, Text } from '@mantine/core';

import dayjs from 'dayjs';

const DateCell = ({ cell, accessorFn, format }) => {
    const { column, row } = cell;
    const rowData = row.original;

    const value = accessorFn(rowData);
    return (
        <Box
            style={{
                display: 'flex',
                alignItems: 'center',
                gap: '16px',
            }}>
            <Stack gap={0}>
                <Text>{value ? dayjs(value).format(format) : '---'}</Text>
            </Stack>
        </Box>
    );
};

const DateTimeColumn = ({ id, header, accessorFn, format = 'MM-DD-YYYY' }) => ({
    id: id || header.toLowerCase(),
    accessorFn: accessorFn,
    header: header,
    size: 2,
    minSize: 160,
    Cell: ({ cell }) => (
        <DateCell
            cell={cell}
            accessorFn={accessorFn}
            format={format}
        />
    ),
});
export default DateTimeColumn;
